import axiosClient from "api/axios_client.js";

// Dropdown data for the settings page. The user's own settings (get/update) live in
// src/api/global-api/api-settings.js because the app header and SettingsContext use them too.
const apiSettings = {
  getCurrencies: () => axiosClient.get(`/directories/system-master/currency/get-all`),
  getTimezones: () => axiosClient.get(`/directories/system-master/timezone/get-all`),
};

export default apiSettings;
